import { jsPDF } from "jspdf";
import format_number from "./number_formatter";

export const showFacture = (factureData) => {
  console.log(factureData, "factureData");
  const deliveryNotesHeader = ["Produit", "Quantité", "Prix", "Total"];
  const doc = new jsPDF();
  const pageWidth = 210;

  const img = new Image();
  img.src = "/logo.png";
  img.onload = () => {
    const x = 15;
    const y = 10;
    const width = 90;
    const height = 30;

    doc.addImage(img, "PNG", x, y, width, height);

    doc.setFontSize(14);
    doc.setFont("Arial", "bold");
    doc.text("STE KOUNOUZ TOURISM SUARL", 20, 50);

    doc.setFontSize(10);
    doc.setFont("Arial", "small");
    doc.text(
      `Société Unipersonnelle à responsabilité limitée\n` +
        `Résidente au capital de 700020.000.000 dinars\n` +
        `Siège social : Rue Italie Immeuble Bouchra – 4000 - Sousse\n` +
        `M.F. : 1214866P/A/M/000 – IU-RNE : 1214866P`,
      20,
      55
    );

    const pageHeight = doc.internal.pageSize.height;
    const pageBottomHeight = pageHeight - 10;
    const pageBottom =
      "Adresse : Rue Italie Immeuble Bochra - 4000 SOUSSE. TUNISIE. MF: 1214866P /AM-000";
    const bottomTextWidth = doc.getTextWidth(pageBottom);
    const bottomTextX = (pageWidth - bottomTextWidth) / 2;
    doc.text(pageBottom, bottomTextX, pageBottomHeight);

    doc.setFont("Arial", "bold");
    doc.text(`Client: ${factureData.customerName}`, 155, 70);

    doc.setFont("Arial", "bold");
    doc.text(`DATE LE: ${factureData.deliveryDate}`, 155, 75);
    doc.setFontSize(18);
    doc.setFont("times", "bold");

    const title = `Facture n°: ${factureData.invoiceNumber || "-"}`;
    const textWidth = doc.getTextWidth(title);
    const textX = (pageWidth - textWidth) / 2;
    doc.text(title, textX, 90);

    doc.setFontSize(12);
    doc.setFont("Arial");

    const drawDeliveryTable = () => {
      doc.setFontSize(12);
      doc.setFont("Arial");

      const startX = 20;
      const startY = 100;
      const columnWidths = [30, 20, 35, 35];
      let y = startY;
      const headerHeight = 10;

      deliveryNotesHeader.forEach((header, index) => {
        doc.setFillColor(200, 200, 200);
        const x =
          startX + columnWidths.slice(0, index).reduce((a, b) => a + b, 0);
        doc.rect(x, y, columnWidths[index], headerHeight, "F");
        doc.setTextColor(0);
        doc.text(header, x + 3, y + 7);
      });

      y += headerHeight;

      factureData.lineModels.forEach((row) => {
        if (row) {
          const attributesToDisplay = [
            "descriptionproduct",
            "quantite",
            "prixunitaire",
            "prixtotal",
          ];
          const rowValues = attributesToDisplay.map((attr) => {
            if (attr === "prixunitaire" || attr === "prixtotal") {
              return row[attr] ? format_number(row[attr]) : "0.000";
            }
            return row[attr];
          });

          rowValues.forEach((item, index) => {
            const columnWidth = columnWidths[index];
            const x =
              startX + columnWidths.slice(0, index).reduce((a, b) => a + b, 0);
            doc.rect(x, y, columnWidth, 10);
            doc.text(String(item), x + 5, y + 7);
          });

          y += 10;

          if (y + 10 > doc.internal.pageSize.height - 10) {
            doc.addPage();
            y = 10;
          }
        }
      });

      const totalLabel = "Montant Total";
      const totalValue = format_number(factureData.totalTtc);
      const labelWidth = columnWidths
        .slice(0, columnWidths.length - 1)
        .reduce((a, b) => a + b, 0);
      const lastColumnX = startX + labelWidth;

      doc.rect(startX, y, labelWidth, 10);
      doc.text(totalLabel, startX + 2, y + 7);

      doc.rect(lastColumnX, y, columnWidths[columnWidths.length - 1], 10);
      doc.text(totalValue, lastColumnX + 5, y + 7);

      return y + 20;
    };

    const drawTvaTable = (startY) => {
      const tvaHeader = ["Taux", "Base", "TVA"];
      const tvaContent = [
        {
          taux: "0.0%",
          base: "0.0",
          tva: "0.0",
        },
      ];
      const startX = 20;
      const columnWidths = [40, 40, 40];
      const headerHeight = 10;
      const rowHeight = 10;

      doc.setFontSize(12);
      doc.setFont("Arial");

      let y = startY;

      tvaHeader.forEach((header, index) => {
        const width = columnWidths[index];
        const x =
          startX + columnWidths.slice(0, index).reduce((a, b) => a + b, 0);
        doc.setFillColor(200, 200, 200);
        doc.rect(x, y, width, headerHeight, "F");
        doc.setTextColor(0);
        doc.text(header, x + 3, y + 7);
      });

      y += headerHeight;

      tvaContent.forEach((row) => {
        const rowValues = Object.values(row);
        rowValues.forEach((item, index) => {
          const width = columnWidths[index];
          const x =
            startX + columnWidths.slice(0, index).reduce((a, b) => a + b, 0);
          doc.rect(x, y, width, rowHeight);
          doc.text(String(item), x + 5, y + 7);
        });
        y += rowHeight;
      });
    };

    const drawTables = () => {
      const deliveryTableEndY = drawDeliveryTable();
      drawTvaTable(deliveryTableEndY);
    };

    const factureBoxY = y + 10;

    const drawSignatureBoxes = () => {
      const boxWidth = 40;
      const boxHeight = 60;
      const borderRadius = 5;

      doc.roundedRect(
        160,
        factureBoxY + 65,
        boxWidth,
        boxHeight,
        borderRadius,
        borderRadius
      );
      const text1 = "Cachet et signature";
      const text1X = 162;
      const text1Y = factureBoxY + 72;
      doc.text(text1, text1X, text1Y);
      doc.line(
        text1X,
        text1Y + 1,
        text1X + doc.getTextWidth(text1),
        text1Y + 1
      );

      doc.roundedRect(
        160,
        factureBoxY + 130,
        boxWidth,
        boxHeight / 2,
        borderRadius,
        borderRadius
      );
      const text2 = "Décharge client";
      const text2X = 165;
      const text2Y = factureBoxY + 137;
      doc.text(text2, text2X, text2Y);
      doc.line(
        text2X,
        text2Y + 1,
        text2X + doc.getTextWidth(text2),
        text2Y + 1
      );
    };

    drawSignatureBoxes();

    drawTables();

    doc.setFontSize(12);

    const pdfBlob = doc.output("blob");
    const blobUrl = URL.createObjectURL(pdfBlob);
    window.open(blobUrl, "_blank");
  };

  img.onerror = () => {
    console.error("Failed to load image");
  };
};
